import './Register.scss';
import { UserAccount } from '../AccountService2';
export class RegisterController {
    static $inject = ['$state', 'AccountService2', 'AuthenticationService', '$location', 'TranslateService', 'SegmentService', '$timeout'];
    constructor($state, AccountService2, AuthenticationService, $location, TranslateService, SegmentService, $timeout) {
        'ngInject';
        this.$state = $state;
        this.AccountService2 = AccountService2;
        this.AuthenticationService = AuthenticationService;
        this.$location = $location;
        this.TranslateService = TranslateService;
        this.SegmentService = SegmentService;
        this.$timeout = $timeout;
        this.loading = false;
        this.paramToken = this.$location.search().token;
        this.account = new UserAccount({
            email: this.paramToken && this.$location.search().email,
        });
        this.hasAcceptedTermsAndPolicy = false;
        this.checkFeatures();
        this.setEmployeesNumber();
    }
    /**
     * Register variables based on feature flags
     */
    async checkFeatures() {
        this.createAccountKey = 'create-account-B';
    }
    /**
     * Set employees number based on static array to be used on blipSelect
     */
    setEmployeesNumber() {
        this.employeesNumber = [
            { label: '1 - 19', value: '1 - 19' },
            { label: '20 - 49', value: '20 - 49' },
            { label: '50 - 249', value: '50 - 249' },
            { label: '250 - 499', value: '250 - 499' },
            { label: '500+', value: '500+' },
        ];
    }
    /**
     * Get segment payload based on feature flags
     */
    getSegmentPayload(account) {
        return {
            account: {
                name: account.fullName,
                email: account.email,
                companyWebsite: account.extras.companyWebsite,
                companySize: account.extras.companySize,
                whatsAppPhoneNumber: account.whatsAppPhoneNumber ? account.whatsAppPhoneNumber : '',
            },
        };
    }
    /**
     * Register new user or update user that comes from team invite
     */
    async register() {
        this.loading = true;
        this.account.emailTemplate = {
            link: `${this.$location.protocol()}://${location.host}/#/activate/${encodeURIComponent(this.account.email)}?token=%token%`,
            cultureInfo: await this.TranslateService.getCurrentLanguage(),
        };
        try {
            /**
             * Set account culture
             */
            const newAccount = {
                ...this.account,
                culture: this.TranslateService.getCurrentLanguage(),
            };
            this.SegmentService.setAccount({
                ...newAccount,
            });
            /**
             * Save user account
             */
            if (this.paramToken) {
                await this.resetAccountAndRegister(newAccount);
            }
            else {
                /**
                 * Login with new account created
                 */
                await this.AuthenticationService.login(newAccount.email, newAccount.password);
                await this.AccountService2.fetchAndSetAccount();
                const payload = this.getSegmentPayload(newAccount);
                this.SegmentService.createTrack(this.createAccountKey, payload);
            }
            /**
             * Go to applications list
             */
            this.$state.go('auth.application.list');
        }
        catch (e) {
            this.registerError = e;
            console.error(e);
        }
        finally {
            this.$timeout(() => {
                this.loading = false;
            }, 1000);
        }
    }
    /**
     * Reset account, update with account infos and login
     */
    async resetAccountAndRegister(newAccount) {
        const { password, ...updatedAccount } = newAccount;
        /**
         * Login with new account created
         */
        await this.AuthenticationService.login(newAccount.email, newAccount.password);
        if (!this.AuthenticationService.getAccount() || this.AuthenticationService.isAccountPending()) {
            await this.AccountService2.save(this.account.email);
        }
        const payload = this.getSegmentPayload(newAccount);
        this.SegmentService.createTrack(this.createAccountKey, payload);
    }
}
RegisterController.$inject = ['$state', 'AccountService2', 'AuthenticationService', '$location', 'TranslateService', 'SegmentService', '$timeout'];
